import { Controller } from "remult";

@Controller("aid-request-form-methods")
export class AidRequestFormMethods {}
